/**
 * Domínio: agrupamento da cadeia de contatos de emergência — GUPM-158.
 * -------------------------------------------------------------------
 * TS puro (sem React/Supabase/DOM). Espelha a classificação do protótipo
 * v5.10 (`showEmergencyContacts`): `role` com RT / PAEBM / EoR / Segurança =
 * cadeia técnica **interna**; o resto = órgãos e emergência **externos**.
 */

export type GrupoContato = 'interna' | 'externa';

/** Termos que marcam a cadeia técnica interna (mesmos do v5.10). */
const TERMOS_INTERNA = ['RT', 'PAEBM', 'EoR', 'Segurança'] as const;

/**
 * Funções de um contato para exibição — GUPM-202. Linha sem `funcoes` (dado de
 * antes da migration 20261015140000, ou fonte que não as traz) mostra o `role`.
 */
export function funcoesDoContato(contato: { funcoes?: readonly string[] | null; role: string }): readonly string[] {
  return contato.funcoes && contato.funcoes.length > 0 ? contato.funcoes : [contato.role];
}

/** Classifica um contato pela função (`role` = funções unidas por " / "). */
export function classificarContato(role: string): GrupoContato {
  return TERMOS_INTERNA.some((termo) => role.includes(termo)) ? 'interna' : 'externa';
}

export interface ContatosAgrupados<T> {
  interna: T[];
  externa: T[];
}

/**
 * Separa os contatos em interna/externa preservando a ordem de entrada
 * dentro de cada grupo. Genérico: serve ao roster (`ContatoSeed`) e ao tipo
 * de UI (`ContatoEmergencia`) — basta ter `role`.
 */
export function agruparContatos<T extends { role: string }>(contatos: T[]): ContatosAgrupados<T> {
  const interna: T[] = [];
  const externa: T[] = [];
  for (const contato of contatos) {
    if (classificarContato(contato.role) === 'interna') interna.push(contato);
    else externa.push(contato);
  }
  return { interna, externa };
}
